import { PaletteColor } from "@brexhq/metal-foundation";
import styled from "@emotion/styled";
import React from "react";

import { Icon, ColoredIcon } from "@brexhq/shared/components/deprecated/Icons";
import {
  IconTypes,
  ColoredIconTypes,
} from "@brexhq/shared/components/deprecated/Icons/types";
import { BreakPointVals } from "@brexhq/shared/styles/breakpoints";

type ResponsiveLayouts = {
  responsive: { [key in BreakPointVals]: IconResponsiveProps };
  color?: PaletteColor;
  icon: IconTypes;
};
type IconResponsiveProps = {
  width?: number | string;
  height?: number | string;
};

type ResponsiveColoredLayouts = Omit<ResponsiveLayouts, "icon"> & {
  icon: ColoredIconTypes;
};

const IconSizeWrapper = styled.div<{
  responsive: ResponsiveLayouts["responsive"];
}>(({ theme, responsive }) => {
  return {
    ["&>svg"]: {
      width: responsive["LRG"]?.width ?? "initial",
      height: responsive["LRG"]?.height ?? "initial",
    },
    [theme.breakpoints.MED]: {
      ["&>svg"]: {
        width: responsive["MED"]?.width ?? "initial",
        height: responsive["MED"]?.height ?? "initial",
      },
    },
    [theme.breakpoints.SML]: {
      ["&>svg"]: {
        width: responsive["SML"]?.width ?? "initial",
        height: responsive["SML"]?.height ?? "initial",
      },
    },
  };
});
export const ResponsiveIcon: React.FC<ResponsiveLayouts> = ({
  responsive,
  color,
  icon,
}) => {
  return (
    <IconSizeWrapper responsive={responsive}>
      <Icon
        icon={icon}
        height={responsive["LRG"]?.height}
        width={responsive["LRG"]?.width}
        color={color}
      />
    </IconSizeWrapper>
  );
};

export const ResponsiveColoredIcon: React.FC<ResponsiveColoredLayouts> = ({
  responsive,
  color,
  icon,
}) => {
  return (
    <IconSizeWrapper responsive={responsive}>
      <ColoredIcon
        icon={icon}
        height={responsive["LRG"]?.height}
        width={responsive["LRG"]?.width}
        color={color}
      />
    </IconSizeWrapper>
  );
};
